import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppBarComponent, FooterComponent } from '@aa/angular/marketing';

@Component({
  standalone: true,
  imports: [RouterModule, AppBarComponent, FooterComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'marketing-site';
}
